<template>
    <b-modal scrollable title="Gestione Parametri Vitali" ref="mdlRsaPazienteParametriVitaliEdit" id="mdlRsaPazienteParametriVitaliEdit" size="xl" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" class="mb-3">
                    <label class="sa-label-data">Parametri da rilevare</label>
                    <b-dropdown variant="outline-primary" class="w-100" menu-class="w-100 p-2 shadow-sm" :disabled="isEditMode" no-caret>
                        <template #button-content>
                            <div class="d-flex justify-content-between align-items-center">
                                <span> <font-awesome-icon icon="list" class="mr-2" /> {{ listaMisure.length > 0 ? listaMisure.join(", ") : "- Selezionare Parametri -" }} </span> <font-awesome-icon icon="chevron-down" size="sm" />
                            </div>
                        </template>

                        <div style="max-height: 250px; overflow-y: auto">
                            <b-form-checkbox v-for="opt in parametriVitaliOptions" :key="opt.value" v-model="listaMisure" :value="opt.value" class="ml-2 mb-2" @change="(checked) => onToggleParametro(checked, opt.value)"> {{ opt.text }} </b-form-checkbox>
                        </div>
                    </b-dropdown>
                </b-col>
            </b-row>

            <hr v-if="groupedParametri.length > 0" />

            <div v-for="(gruppo, index) in groupedParametri" :key="index" class="mb-4">
                <div class="sa-flexbox-body-title bg-light p-2 border d-flex justify-content-between align-items-center">
                    <span><font-awesome-icon icon="heartbeat" class="mr-2 text-primary" />{{ gruppo.nome }}</span> <b-button size="sm" variant="link" class="text-danger" @click="rimuoviParametro(gruppo.nome)" v-if="!isEditMode"> <font-awesome-icon icon="times" /> </b-button>
                </div>

                <div class="p-3 border border-top-0">
                    <b-row>
                        <b-col v-for="(m, mi) in gruppo.misurazioni" :key="mi" cols="12" md="6" lg="4" class="mb-3">
                            <label class="small font-weight-bold">{{ getLabelTraduora(m.measurename) }}</label> <b-input-group :append="m.unitaMisura" size="sm"> <b-form-input v-model="m.value" type="number" step="0.1" class="sa-input text-right"></b-form-input> </b-input-group>
                            <small class="text-muted">Range: {{ m.valoririferimento.min }} - {{ m.valoririferimento.max }}</small>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <b-row>
                <b-col cols="12"> <label class="sa-label-data">Note / Osservazioni</label> <b-form-textarea v-model="jsonData.note" rows="3" class="sa-input"></b-form-textarea> </b-col>
            </b-row>
        </div>

        <template #modal-footer> <b-button size="md" variant="outline-success" @click="onSalva">Salva</b-button> <b-button size="md" variant="outline-danger" @click="onClickUndo">Annulla</b-button> </template>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResourceConfig: "/rsaconfigurazioneparametrivitali",
            pathResource: "/rsaparametrivitalitestate",
            idAccettazione: null,
            idPresidio: null,
            listaMisure: [],
            groupedParametri: [],
            parametriVitaliOptions: [],
            jsonData: {
                id: null,
                idAccettazione: "",
                descrizioneMisurazione: "",
                note: "",
                listaParametriVitaliValori: [],
            },
        };
    },
    computed: {
        isEditMode() {
            return this.jsonData.id !== null && this.jsonData.id !== "";
        },
    },
    methods: {
        show(id, idPresidio = null, idAccettazione = null) {
            let me = this;
            me.idAccettazione = idAccettazione === null ? this.$route.query.idAccettazione : idAccettazione;
            me.idPresidio = idPresidio; // Reset dati

            me.listaMisure = [];
            me.groupedParametri = [];
            me.jsonData = {
                id: id,
                idAccettazione: me.idAccettazione,
                note: "",
                listaParametriVitaliValori: [],
            };

            me.loadParametriOptions();

            if (id !== null) {
                me.loadDataRecord(id);
            }

            me.$refs.mdlRsaPazienteParametriVitaliEdit.show();
        },

        loadParametriOptions() {
            let me = this;
            UtilityMixin.methods.loadDataResources(
                `${me.pathResourceConfig}/presidio`,
                { idPresidio: me.idPresidio },
                (res) => {
                    const list = res.data.data.list; // Mappiamo le opzioni mantenendo traccia del campo obbligatorio

                    me.parametriVitaliOptions = list.map((el) => ({
                        value: el.descrizione,
                        text: el.descrizione,
                        obbligatorio: el.obbligatorio,
                    })); // Se siamo in fase di CREAZIONE (non in modifica), pre-selezioniamo quelli obbligatori

                    if (!me.isEditMode) {
                        list.forEach((el) => {
                            if (el.obbligatorio && el.obbligatorio.toUpperCase() === "SI") {
                                if (!me.listaMisure.includes(el.descrizione)) {
                                    me.listaMisure.push(el.descrizione);
                                    me.onToggleParametro(me.listaMisure, el.descrizione);
                                }
                            }
                        });
                    }
                },
                (err) => UtilityMixin.methods.messaggeBoxError(me, err),
            );
        },

        onToggleParametro(checked, nome) {
            let me = this;
            if (checked.includes(nome)) {
                const link = `${process.env.VUE_APP_PATH_API}${me.pathResourceConfig}/parametro/${nome}`;
                UtilityMixin.methods.restCallGet(link, null, (res) => {
                    const dett = res.data.data;
                    me.groupedParametri.push({
                        nome: nome,
                        misurazioni: dett.listaMisurazioni.map((m) => ({
                            measurename: m.misura,
                            value: null,
                            valoririferimento: { max: m.valoreMassimo, min: m.valoreMinimo },
                            unitaMisura: m.unitaMisura,
                        })),
                    });
                });
            } else {
                me.groupedParametri = me.groupedParametri.filter((g) => g.nome !== nome);
            }
        },

        rimuoviParametro(nome) {
            this.listaMisure = this.listaMisure.filter((m) => m !== nome);
            this.groupedParametri = this.groupedParametri.filter((g) => g.nome !== nome);
        },

        loadDataRecord(id) {
            let me = this;
            const link = `${process.env.VUE_APP_PATH_API}${me.pathResource}/${id}`;
            UtilityMixin.methods.restCallGet(link, null, (res) => {
                me.jsonData = res.data.data;
                if (me.jsonData.descrizioneMisurazione) {
                    me.listaMisure = me.jsonData.descrizioneMisurazione.split(", ");
                    me.groupedParametri = [
                        {
                            nome: "Rilevazioni",
                            misurazioni: me.jsonData.listaParametriVitaliValori,
                        },
                    ];
                }
            });
        },

        onClickUndo() {
            this.$refs.mdlRsaPazienteParametriVitaliEdit.hide();
        },

        onSalva() {
            let me = this;
            // if (me.listaMisure.length === 0) {
            //     UtilityMixin.methods.messaggeBoxError(me, "Selezionare almeno un parametro.");
            //     return;
            // }

            me.jsonData.descrizioneMisurazione = me.listaMisure.join(", ");
            let flatList = [];
            me.groupedParametri.forEach((g) => {
                g.misurazioni.forEach((m) => {
                    flatList.push({ measurename: this.getLabelTraduora(m.measurename), value: m.value });
                });
            });
            me.jsonData.listaParametriVitaliValori = flatList;

            this.saveResource(
                me.pathResource,
                me.jsonData,
                (res) => {
                    res;
                    me.$emit("saveSuccess");
                    me.$refs.mdlRsaPazienteParametriVitaliEdit.hide();
                },
                (err) => UtilityMixin.methods.messaggeBoxError(me, err),
            );
        },
    },
};
</script>
